import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { SidePanel } from '@alfa-bank/newclick-composite-components/side-panel';
import cn from 'classnames';
import { voipScreens } from '../../constants/types';
import { useVoipContext } from '../../hooks/use-voip-context';
import { useWidgetContext } from '../../hooks/use-widget-context';
import styles from './index.module.css';
export const CollapsedDisabledLayout = ({ onClose, background, children }) => {
    const { phone, remoteAudioVideo, setVoipScreen } = useVoipContext();
    const { theme } = useWidgetContext();
    useEffect(() => () => {
        setVoipScreen(voipScreens.WITHOUT_CALL);
        phone.deinit();
    }, [phone, setVoipScreen]);
    return (_jsxs(React.Fragment, { children: [_jsx(SidePanel, { open: true, onClose: onClose, nativeScrollbar: true, className: cn(styles[background], styles[theme]), disableBackdropClick: true, children: children }), _jsx("audio", { ref: remoteAudioVideo, autoPlay: true })] }));
};
